import { useEffect, useState } from 'react';
import style from './BrandDetailComponent.module.css'

import Footer from 'component/footer/FooterComponent';

import bannerLogo from 'assets/brand_detail/banner_logo.png'
import content1 from 'assets/brand_detail/content1.png'

const BrandDetail = (props) => {
  const [date, setDate] = useState('')

  useEffect(() => {
    const query = window.location.search
    const dateValue = query.match(/date=([^&]+)/)

    if (!dateValue[1]) return

    setDate(dateValue[1])
  })
  
  return (
    <div className={style.page_box}>
      <div className={style.banner}>
        <h2 className={style.banner_title}>品牌动态</h2>
        <h4 className={style.banner_subtitle}>活动 合作 荣誉</h4>
        <img src={bannerLogo} />
      </div>

      <div className={style.content_header}>
        <p>{'首页>正文'}</p>
      </div>

      {
        date === '2025-03' &&
        (
          <div className={style.content_wrap}>
            <div className={style.main_header}>对湖南省认定机构2024年认定报备的第一批高新技术企业进行备案的公示</div>

            <p>根据《高新技术企业认定管理办法》（国科发火〔2016〕32号）和《高新技术企业认定管理工作指引》（国科发火〔2016〕195号）有关规定，现将湖南省认定机构2024年认定报备的第一批2297家高新技术企业（企业名单详见附件）进行备案公示，公示期为10个工作日。</p>

            <p>对公示企业有异议的，请在公示期内以实名、书面形式向全国高新技术企业认定管理工作领导小组办公室反映，反映情况须客观真实，以单位名义反映情况的材料需加盖单位公章，以个人名义反映情况的材料应署真实姓名并提供有效联系方式。</p>

            <p>传真：010-68209157</p>

            <p>附件：湖南省认定机构2024年认定报备的第一批高新技术企业备案公示名单</p>
      
            <p style={{ marginTop: 0 }}>http://www.innocom.gov.cn/gqrdw/c101428/202411/bb0fe81bf9874f22b198878c534b2405/files/948c054b199045fbbb9a044d413fa9f6.pdf</p>

            <p className={style.right_txt}>全国高新技术企业认定管理工作领导小组办公室</p>

            <p className={style.right_txt} style={{ marginTop: 0 }}>2024年11月1日</p>
          </div>
        )
      }

      {
        date === '2024-12' &&
        (
          <div className={style.content_wrap}>
            <div className={style.main_header}>2024国际在线教育大会专访：冲鸭教育教研总监朱威</div>
            
            <p>教育是民族振兴、社会进步的基石，是提高国民素质、促进人的全面发展的根本途径。12月19日，2024年国际在线教育大会顺利举办。此次大会从教育的深度改革与探索出发，汇聚教育领域顶尖的教育专家、行业先锋、知名校长、优秀的一线教育工作者以及众多权威媒体代表，旨在深度剖析当前教育领域的热点问题，探索智慧教育的最新趋势与实践路径，携手构建更加开放、包容、创新的教育生态系统。多角度、全方位地审视中国教育的变革与发展，为教育事业的蓬勃兴盛搭建起高端的对话平台与合作桥梁。</p>

            <p>受2024年国际在线教育大会邀请，冲鸭教育教研总监朱威接受了专访，以下是专访实录。</p>

            <img src={content1} />

            <h3>冲鸭教育教研总监朱威</h3>

            <p>主持人：各位网友大家好，这里是2024国际在线教育大会访谈间的现场，今天我们很荣幸邀请到冲鸭教育教研总监朱威，欢迎您朱威老师，接下来给网友打个招呼，同时也做个自我介绍吧。</p>

            <p>朱威：大家好！我是冲鸭教育教研总监朱威，很高兴在这里跟各位网友见面！</p>

            <p>主持人：在全球化国际竞争激烈的背景下，教育在培养学生的国际竞争力方面发挥着至关重要的作用 贵校/机构 有哪些举措呢?</p>

            <p>朱威：冲鸭教育提倡“好玩实用”的教学理念，我们带给学员的不仅仅是更高质量的语言和文化知识，更高效率的学习方法，还有更多的实践和锻炼机会。</p>

            <p>一方面，我们注重“实用”，专注于教育的核心竞争力的升级：提升师资团队、优化教学方法、迭代教学工具等。</p>

            <p>目前冲鸭硕博教师占比超 80%且近 95%有海外留学背景，基于此，冲鸭教育教研团队研发了适合学生的“IPT”教学法和特色任务墙，同时，获众多博主推荐的“冲鸭日语”“冲鸭韩语”APP，为日韩语学者提供高质量学习平台。</p>

            <p>另一方面，我们也兼顾“好玩”，重视学员的个性发展，举办师生教学互动交流活动，给学员更多实践和锻炼机会，更好地和国际接轨。</p>

            <p>我们联动行业大咖，主办了26 期“小语种行业分享会”，多次联动漫展活动。并获多方认可，荣获多项行业荣誉。今年开启的“公益课”项目更是由硕博讲师免费授课，帮助更多学员规划留学、接轨国际教育、圆梦小语种学习。</p>

            <p>主持人：面对教育行业的快速变化，您认为未来教师需要具备哪些关键能力，以应对教育行业的快速变化?</p>

            <p>朱威：冲我们认为最关键的就是与时俱进，新的时代下，老师务必要有更专业的能力和更活跃的创新思维。</p>

            <p>首先是过硬的专业能力。时代在进步，对学历和经验等的要求也会越来越高，冲鸭教师团现在硕博占比超80%，海外留学背景的教师占比近95%。老师还会定期进行教学研讨会，精心打磨课程，优化教学方式和服务，编写整理自己的教研资料，确保给到大家的课程服务是“最优解”，是真正实用、有帮助的内容。</p>

            <p>其次是需要具备创新精神。冲鸭教研团致力于提高教学质量和体验，提倡“寓教于乐”，教研老师们会关注国际上日韩最新资讯，如KPOP、韩剧、动漫等，并将其巧妙融入课堂，简化复杂知识，研发IPT教学法，直击学习难点，营造愉悦学习氛围，让学员更好地和国际接轨。</p>

            <p>以上也就是我们冲鸭教育一直强调的“实用”和“好玩”的教学理念。</p>

            <p>主持人：教育技术在提升教学效果和学习体验方面发挥着越来越重要作用。贵校/机构如何应用教育的技术?</p>

            <p>朱威：冲在数字化时代，互联网对教育的推动作用愈加显著。冲鸭教育充分认识到这点，投入大量时间和资源，成功开发了既好玩又实用，集学习、练习、测试及趣味互动于一体的冲鸭日语APP和冲鸭韩语APP，给日韩语学者提供了详尽的五十音和四十音教学，帮助初学者快速掌握发音。</p>

            <p>同时，APP配备了丰富的词库、听力练习、趣味文化小知识，可以提升学习效率和综合语言能力，为学员提供了优质的学习资源的同时也帮助学员实现“学练测”无缝衔接的沉浸式学习体验。</p>

            <p>APP自上线以来广获好评，众多学习博主积极推荐，冲鸭日语APP甚至一度攀升至iOS日语软件搜索榜第三，荣获清华大学语言中心副教授梁爽老师的推荐，这都是对我们在教育技术领域突出表现的认可。</p>
          </div>
        )
      }

      {
        date === '2024-09' &&
        (
          <div className={style.content_wrap}>
            <div className={style.main_header}>关于公布湖南省2024年第二批入库科技型中小企业名单的通知</div>

            <p style={{ textIndent: 0 }}>各市州科技局、省直管试点县市科技行政主管部门:</p>
  
            <p style={{ marginTop: 0 }}>根据《科技型中小企业评价办法》（国科发政〔2017〕115号）和《科技型中小企业评价服务工作指引》（国科火字〔2022〕67号）要求，湖南省2024年第二批拟入库科技型中小企业已完成公示。公示期间，经异议核实处理等工作，共有4家企业不符合科技型中小企业条件。现将通过公示的湖南省2024年第二批5204家入库的科技型中小企业名单予以公布。</p>

            <p>附件：湖南省2024年第二批入库科技型中小企业名单</p>

            <p style={{ marginTop: 0 }}>https://kjt.hunan.gov.cn/kjt/xxgk/tzgg/tzgg_1/202409/33463866/files/7e357b6e545e48cc8ab8f075abdb8137.pdf</p>

            <p className={style.right_txt}>湖南省科学技术厅</p>

            <p className={style.right_txt} style={{ marginTop: 0 }}>2024年9月26日</p>
          </div>
        )
      }

      {
        date === '2023-10' &&
        (
          <div className={style.content_wrap}>
            <div className={style.main_header}>冲鸭教育：用语言突破世界的边界</div>

            <p>人才是创新之核、发展之要、强国之基。随着全球化的推进，各国之间的交流与合作日益频繁，小语种人才作为跨文化沟通的桥梁、经济贸易往来的纽带，在促进不同国家和民族之间相互理解与合作中以及在人类命运共同体建设中有着举足轻重的作用。</p>

            <p>但目前，在国际市场上仍存在巨大的小语种人才缺口，一方面是进入新时代，我国与周边国家经贸合作不断迈上新台阶，对小语种人才的需求激增，另一方面是“实战性”小语种人才的缺乏。如何培养更广泛意义上的“实战性”小语种人才，成为摆在我国教育工作者面前的一道新问题。其中冲鸭教育作为小语种培训领域的佼佼者，基于“语言是世界的边界”的品牌主张，不仅为国际市场上输送了众多优秀的小语种人才，其构建的全新小语种教育模式也为此行业注入了新鲜活力。</p>

            <p>创新教育理念，培养“实战性”小语种人才</p>

            <p>冲鸭教育是一家以自有研发小语种课程内容体系和强监督服务模式为特色的“互联网+教育”创新科技企业。始于2018年一群中国留学生于日本创立的中文学堂，历经五年快速发展，已帮助5万+学员进行深度语言学习。</p>


            <p>冲鸭教育始终坚信语言的重要性远远超出了沟通工具的范畴，它是我们理解世界、认识世界、跨越边界的关键。通过语言，我们能够超越地域、国界和文化差异，建立起更加紧密的联系和合作。因此冲鸭教育致力于提供一流的小语种教育课堂，以培养听、说、读、写、译全面发展的实战性小语种人才为目标，帮助学生突破语言的限制，拓宽视野，增强自身的核心竞争力，实现跨文化交流与沟通。“好玩实用”是冲鸭教育提出的创新性教育理念，并将其贯彻课程教学始终，特色小语种活动、趣味多元衍生课程、实训任务墙等都是其教育理念的具象化体现，激发学员在学习上的主观能动性。</p>

            <p> 以学生体验为首，不断改善优化教学服务</p>

            

            <p>近日，冲鸭教育的日语课程迎来全新升级，重磅推出制霸直播班，资深名师全直播授课、双轨学习，高效提升、高达217节直播课直通高阶。除此之外每周外教课翻倍，重金聘请资深外教，学员能接触更地道的日语发音，培养流利的日语口语。并且冲鸭教育的老学员免费体验以上全部升级内容。这一系列举措不仅彰显了冲鸭教育对教学的专注，更体现了其以学生为本的决心。冲鸭教育以品牌实力、教研实力和学生为本的理念，成为业内瞩目的教育品牌。</p>


            <p>
              教研实力是冲鸭教育持续升级课程的重要保障。冲鸭教育拥有一支高素质的教师团队，他们具备丰富的教学经验和专业的教育背景。教师们通过持续的教研活动和不断的专业培训，保持对最新教学方法和理论的了解，并灵活运用于课堂教学中。并且冲鸭教育会定期组织学生需求调研，让专业老师及时了解学员的反馈意见，这种持续的教研投入为冲鸭教育提供了更新、更符合学生需求的课程内容，有效提升教学质量。
              <br />
              冲鸭教育凭借多年的经验和卓越的教学成果，以及扎实的品牌基础，赢得广大学员和家长的信任，收获行业内外一致的赞赏。据冲鸭教育的负责人透露，冲鸭教育将持续优化升级课程，为学员带来更优质的学习体验，为社会持续输送实战型小语种人才。
            </p>
   
          </div>
        )
      }

      {
        date === '2023-07' &&
        (
          <div className={style.content_wrap}>
            <div className={style.main_header}>冲鸭教育探索在线教育新模式</div>

            <p>近期，冲鸭教育不断收获行业大咖的认可，不仅被清华大学教授推荐，更联合国际知名大学学府举办了“国际小语种行业交流会”，邀请到东京大学博士、庆应大学讲师进行直播分享交流。交流会旨在为世界各地小语种学习者提供与行业大咖交流沟通的平台，帮助语言学习者更好地掌握语言学习干货，打开眼界，提升语言学习的思维，同时冲鸭教育也希望为社会培养、输送“实战型”小语种人才。</p>


            <p>
              作为专注小语种学习的机构，冲鸭教育始终认为教育品牌的力量最终是学习者自己。冲鸭教育深耕小语种教学领域，始终践行“好玩实用”的教育理念、致力于打造专业、好玩、实用、负责的一流线上小语种教育课堂，不断调整改善教学服务，始终关注学生的学习体验，让每一位学生都能感受到自我提升的喜悦以及不同的课程体验丰富学习过程。
              <br />
              此次作为主办方推出的“国际小语种行业交流会”更是一次大胆的尝试与突破，为小语种教育领域注入新鲜活力，收获行业内外一致好口碑，同时也彰显出冲鸭教育在小语种教学上的决心与担当。
            </p>

            <p>学习结果导向，不断优化升级教学</p>
            
            <p style={{ marginTop: 0 }}>冲鸭教育坚持以学习结果为导向，严格把控教师团队的质量，每位任教老师皆为名校毕业，拥有丰富的教学经历，擅长以深入浅出的方式讲解语言知识，贯彻“因材施教”的教学方式。专业老师会对入学学员进行深入的了解，从学员自身的基础、学习状况、目标需求等方面出发，综合考虑下量身定制专属学习计划。并且会定期开展学习测验，通过学生成绩反馈与问卷调研，及时调整课程节奏与学习计划，冲鸭教育坚信只有科学的学习节奏，才能最大化提高学习效率。</p>


            <p>高质量的教学离不开教研，教研与教学两者相辅相成。冲鸭教育同时将目光聚焦在教学研究上，他们深知教材资料的质量对学习成果的影响，因此不断投入精力进行研发，确保资料内容的科学性、系统性和实用性。调研学员学习需求，研发出更符合学员需求的学习资料，无论是相关知识点的梳理还是配套的实例，都力求做到精益求精，助力高效语言学习。</p>

            <p>贯彻“好玩实用”，将学生放在首位</p>

            <p style={{ marginTop: 0 }}>冲鸭教育提倡“严谨而不严肃”的教学风格，以严谨态度把关教学质量，以轻松愉悦的学习氛围，用心的服务态度，让每位学员实现“寓教于乐”的教学体验。教学中根据费曼学习法制定趣味任务墙。任务种类丰富多样，在完成任务的过程里拓宽语言知识，完成后还有丰厚的奖励，这种游戏闯关的学习形式极大激发学生的自主性，调动学生在学习上的自驱力。此外，冲鸭教育还开设了多元衍生选修课程，学生能自由选择感兴趣的课程并深入学习。</p>


            <p>本次举办的“国际小语种行业交流会”更是“好玩实用”理念下的具象化的产物，冲鸭教育每月邀请小语种领域杰出的人才分享语言学习、考研留学、外企工作、考试规划等相关的经验。一方面体现冲鸭教育对学员的重视，这些分享会不仅为学员提供了与行业大牛互动的机会，还能让学员更清晰自己的学习目标，激发学习动力，并且获得更多的学习资源和技巧，让他们在语言学习的道路上更进一步。另一方面也彰显出冲鸭教育在小语种教育领域的专业性，实打实地培养出优秀小语种人才且获得行业的认可与信赖。</p>


            <p>未来，相信冲鸭教育能继续坚守初心，不断优化升级教学模式，给学员带来更完善、更系统的教学服务。</p>
          </div>
        )
      }


      <div>
        <Footer type='about' />
      </div>
    </div>
  )
}

export default BrandDetail